<template>
  <div class="cadastro-usuario cadastro-usuario-notification">
    <v-container
      fluid
    >
      <!-- <h1 class="titulo">Envio de SMS</h1> -->
      <div class="box-table">
        <v-skeleton-loader
          :loading="loadingTable"
          :transition="'fade-transition'"
          height="500"
          type="table">
          <v-data-table
            v-model="item.entityIds"
            :headers="headers"
            :search="search"
            :items="itensEntities"
            width="300px"
            max-width="900px"
            :single-select="singleSelect"
            show-select
            flat
            hide-default-footer
            :loading="loadingPag"
            :items-per-page.sync="itemsPerPage">
            <template v-slot:top>
              <v-switch v-model="singleSelect" label="Single select" class="pa-3"></v-switch>
            </template>
              <template v-slot:top>
                <!-- Select tipo de entidade -->
                <BrToolBar @search="buscar" :configFilter="{ listaSelect: listKeys, getItens: getItensEntities, jsonData: true }" :select="listaTipoBusca">
                <v-menu
                  transition="slide-y-transition"
                  bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="btn-filtro"
                      v-on="on"
                      tile
                      outlined
                    >
                      Instituição
                    </v-btn>
                  </template>
                </v-menu>
                
                </BrToolBar>
              </template>
             

              <template v-slot:item.phone="{ item }">
                {{ item.phone | phone }}
              </template>

              <template v-slot:item.document="{ item }">
                {{ item.document | document }}
              </template>

              <template v-slot:item.action="{ item }">
                <v-btn
                  v-if="permiteAcao($route, 'edit')"
                  small
                  @click="editItem(item)"
                  tile
                  outlined 
                  :color="variables.colorPrimary"
                  class="mr-2"
                >
                  Editar
                </v-btn>

                <v-btn
                  v-if="permiteAcao($route, 'delete')"
                  small
                  @click="deleteItem(item)"
                  tile
                  outlined 
                  :color="variables.colorError"
                >
                  Excluir
                </v-btn>
              </template>

              <template v-slot:footer>
                <div class="wrapper-footer">
                  <div class="qtd-paginacao">
                    {{ pageStart }}
                    -
                    {{ pageStop }}
                    de
                    {{ totalItemSelectMensagemIndividual }}
                  </div>
                  <v-pagination
                    v-model="page"
                    :length="numberOfPages"
                    circle
                    :disabled="disabled"
                    :total-visible="7"
                    class="box-table-paginacao"
                    v-if="numberOfPages > 1"></v-pagination>
                  <v-btn color="primary" @click="modalOpen()" class="br-btn"> Cadastrar notificação</v-btn>
                </div>
              </template>
          </v-data-table>
        </v-skeleton-loader>
      </div>

      <v-btn class="mx-2 fab-cadastrar-usuario" fab color="primary" @click="cadastrar">
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Events from '@/core/service/events'
import listagemTables from '@/views/mixins/listagemTables'
import { map, size } from 'lodash'

export default {
  name: 'EnvioSMS',
  components: {
    BrToolBar: () => import('./components/toolbar')
  },
  mixins: [listagemTables],
  data: () => ({
    singleSelect: false,
    headers: [
      { align: 'start', class: 'table-header', text: 'ID', value: 'id' },
      { align: 'start', class: 'table-header', text: 'Nome', value: 'name' },
      { align: 'start', class: 'table-header', text: 'Telefone', value: 'phone' },
      { align: 'start', class: 'table-header', text: 'CPF/CNPJ', value: 'document' }
    ],
    tipoBusca: 6,
    listaTipoBusca: [
      {text: 'ATS', value: 1 },
      {text: 'OSC ', value: 2 },
      {text: 'CREDENCIADOR ', value: 3 },
      {text: 'ESTABELECIMENTO ', value: 4 },
      {text: 'CAIXA ', value: 5 },
      {text: 'USUARIO WEB ', value: 6 },
      {text: 'INFLUENCIADOR', value: 7 }
    ],
    typeBusca: 'entities',
    itensSelect: []
  }),
  computed: {
    ...mapGetters('notificacao', ['listaItens', 'totalItemSelectMensagemIndividual','itensEntities', 'item']),
    listKeys () {
      return { name: '', telefone: ''}
    },
    numberOfPages () {
      return Math.ceil(this.totalItemSelectMensagemIndividual / this.$store.getters.ItensPaginacao)
    },

    itemsPerPage () {
      return this.$store.getters.ItensPaginacao
    },

    pageStop () {
      const result = this.$store.getters.ItensPaginacao * this.page
      return result < this.totalItemSelectMensagemIndividual ? result : this.totalItemSelectMensagemIndividual
    },

    pageStart () {
      return this.pageStop - this.itensEntities.length + 1
    }
  },
  created () {
    // this.filtroEntities()
  },
  mounted () {
    // const vm = this
    // Events.$on('sms:clearTable', () => {
    //   console.log('chegou aqui')
    //   vm.itensSelect = [] })
  },
  watch: {
    tipoBusca (v) {
      this.addFiltroAtual(v).then(() => this.filtroEntities(v) )
    },
    itensSelect (val) {
      this.addDadosTable(this.envioSms(val))
    }
  },
  methods: {
    ...mapActions('notificacao', { getItens: 'getItens', getItensEntities: 'obterItens' }),
    ...mapActions('notificacao', ['addFiltroAtual', 'addDadosTable']),

    modalOpen () { Events.$emit('Dados::modal::sms') },

    filtroEntities (v = false) {
      const vm = this
      this.getItensEntities({
        pageSize: this.$store.getters.ItensPaginacao,
        _filter: { "entityTypeId_In":`${ !v ? this.tipoBusca : v}` }
      }).then(() => {
        vm.loadingTable = false
      })
    },
    envioSms () {
      let {itensSelect} = this
      return size(itensSelect) !== 0 ? map(itensSelect, v => ({numero: v.phone}) ) : []
    }
  }
}
</script>

<style lang="scss">
  @import '~@/assets/styles/components/table';
  .v-data-table thead tr th,
  .v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
    color: $colorPrimary !important;
  }

  .box-table {
    .v-data-table-header-mobile {
      display: none;
    }
  }

  .fab-cadastrar-usuario {
    position: fixed;
    z-index: 1;
    bottom: 25px;
    right: 5px;

    @media (min-width: 599px) {
      display: none !important;
    }
  }

  .cadastro-usuario-notification .v-data-table__wrapper table {
    min-width: 1000px;
  }
  // .filtro-entities{
  //   position: absolute;
  //   z-index: 1;
  //   top: -16.5px;
  //   @media(max-width: 600px){
  //     position: relative;
  //     width: 100% !important;
  //   }
  // }
</style>>
